<svg width="20" height="26" xmlns="http://www.w3.org/2000/svg">
  <g [attr.stroke]="(colorName ? (colorName | color) : color)" fill="none" fill-rule="evenodd" stroke-linecap="round"
    stroke-linejoin="round">
    <path
      d="M14 10a3.994 3.994 0 01-4 4 4.004 4.004 0 01-3.787-2.705 4.015 4.015 0 01-.099-2.244 3.998 3.998 0 015.882-2.518A3.998 3.998 0 0114 10z" />
    <path
      d="M10 26s-7.307-9.546-8.52-13.086a9.035 9.035 0 01-.222-5.05A8.996 8.996 0 019.997 1M10 26s7.307-9.546 8.52-13.086a9.035 9.035 0 00.222-5.05A8.996 8.996 0 0010.003 1" />
  </g>
</svg>
